<template>
  <div class="z-loadingPanel">
    <div class="z-mark"></div>
    <div class="z-loadingContent t-center">
      <img src="@/images/loading.gif"/>
    </div>
  </div>
</template>
<script type="text/babel">

  export default {
    props:[],

    data() {
      return {
        onClose:null,
        test: ""
      };
    },

    mounted(){
    },

    methods: {
      close:function(){
        this.$destroy(true);
        this.$el.parentNode.removeChild(this.$el);
      }
    },

    computed: {
      
    }
  };
</script>

<style lang="scss" scoped>
  .z-mark{
    position: fixed;
    top:0;
    left:0;
    right:0;
    bottom:0;
    z-index:6666;
    background-color: rgba(0,0,0,.5);
  }

  .z-loadingContent{
    position: fixed;
    top:50%;
    left:50%;
    height:120px;
    width:400px;
    margin-left:-200px;
    margin-top: -60px;
    background-color: #fff;
    border-radius: 8px;
    z-index:7777;
    img{
      width:120px;
      height:120px;
    }
  }

  @media (max-width: 768px){
    .z-loadingContent{
      width:120px;
      margin-left:-60px;
      img{
        border-radius: 8px;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/element/loading/Loading.vue